import { createSelector } from 'reselect';

export default createSelector(
    (state, reservationHash) => ({
        ticketTypes: state.current_event.ticketTypes,
        reservationHash,
    }),
    ({ ticketTypes, reservationHash }) => (
        Object.values(ticketTypes).find(
            // eslint-disable-next-line camelcase
            ticketType => ticketType.related_subscription_config?.reservation_hash === reservationHash,
        )
    ),
);
